<template>
    <div class="review">
        <div class="addBtn" @click="add"> <a-button type="primary">测试任务发起</a-button></div>
        <a-tabs v-model:activeKey="activeKey">
            <a-tab-pane v-for="item in tabList" :key="item.value" :tab="item.name">
                <div class="query-item">
                    <div class="search-l">
                        <div>
                            测试主体
                            <a-input class="inp ml24" placeholder="请输入" v-model:value="query.application"></a-input>
                        </div>
                        <div class="ml28">
                            测试类型
                            <a-select v-model:value="query.status" class="inp ml24" placeholder="请输入">
                                <a-select-option value="">全部</a-select-option>
                                <a-select-option :value="0">一般道路测试</a-select-option>
                                <a-select-option :value="1">高速公路测试</a-select-option>
                                <a-select-option :value="2">一般道路载人示范应用</a-select-option>
                                <a-select-option :value="3">一般道路载物示范应用</a-select-option>
                                <a-select-option :value="4">高速公路载物示范应用</a-select-option>
                            </a-select>
                        </div>
                        <div v-if="activeKey === 1" class="ml28">
                            审批结果
                            <a-select v-model:value="query.result" class="inp ml24" placeholder="请输入">
                                <a-select-option value="">全部</a-select-option>
                                <a-select-option :value="0">审批通过</a-select-option>
                                <a-select-option :value="1">审批不通过</a-select-option>
                            </a-select>
                        </div>
                        <a-button class="ml40" @click="search" type="primary" ghost>查询</a-button>
                        <a-button class="ml24" @click="reset" type="primary" ghost>重置</a-button>
                    </div>
                    <div class="mr24" v-if="activeKey === 0">
                        <a-button @click="batchPass" type="primary">
                            <CheckCircleOutlined />批量通过
                        </a-button>
                    </div>
                </div>
                <a-table
                    :row-selection="activeKey === 1 ? null : { selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                    :columns="curColumn" :row-key="(record) => record.id" :data-source="dataSource" class="mt23"
                    size="middle" :pagination="pagination" :scroll="{ x: 1500, y: 'auto' }"
                    v-autoHeight="{ extraHeight: 88, trHeight: 47 }">
                    <template #bodyCell="{ column, record }">
                        <template v-if="column.key === 'createTime'">
                            {{ moment(record.createTime).format("YYYY-MM-DD HH:mm:ss") }}
                        </template>
                        <template v-else-if="column.key === 'action'">
                            <span>
                                <a class="mr10" @click="detail(record)">详情</a>
                                <span v-if="activeKey === 0">
                                    <a @click="audit(record)">审批</a>
                                </span>
                            </span>
                        </template>
                    </template>
                </a-table>
            </a-tab-pane>
        </a-tabs>

        <reviewModal :modalTitle="'提示'" :modalWidth="'446px'" :isDetailStatus="true" ref="modalRef">
            <div class="content">
                是否批量通过？
            </div>
        </reviewModal>

        <reviewModal :modalTitle="'审核'" :modalWidth="'582px'" :isDetailStatus="true" ref="modalRefJoint">
            <div class="mt32 mb56">
                <div class="radio_class">
                    <span style="padding-left: 14px;">审批结果</span>
                    <a-radio-group class="ml26" v-model:value="radioValue">
                        <a-radio :value="0">通过</a-radio>
                        <a-radio :value="1">不通过</a-radio>
                    </a-radio-group>
                </div>
                <div class="radio_class mt24 area_class">
                    <span style="padding-left: 14px;">审核意见</span>
                    <a-textarea class="area_width" v-model:value="textAreaValue" placeholder="审核不通过时为必填" :rows="4" />
                </div>
            </div>
        </reviewModal>

    </div>
</template>
<script setup>
import { ref, reactive, toRefs, onBeforeMount, onMounted, nextTick, watch, computed } from 'vue'
import { useRouter } from "vue-router";
import reviewModal from '@/components/modal/index.vue'
import uploadButton from '@/components/uploadButton/index.vue'
import useUserStore from '@/store/modules/user'
import { columns, columns2 } from './index.js'
const router = useRouter();

const activeKey = ref(0);
const store =useUserStore();

const tabList = ref([
    { value: 0, name: '待审核' },
    { value: 1, name: '已审核' },
])

let query = reactive({
    application: "",
    status: "",
    result: ""
});

const search = () => {
    pagination.current = 1;
    getData();
};

const reset = () => {
    query.application = "";
    query.status = "";
    query.result = "";
    pagination.current = 1;
    getData();
};

let dataSource = ref([]);
const selectedRowKeys = ref([])
const radioValue = ref(0)
const textAreaValue = ref('')

const onSelectChange = key => {
    console.log('selectedRowKeys changed: ', key);
    selectedRowKeys.value = key;
};

const pagination = reactive({
    total: 0,
    size: "middle",
    defaultPageSize: 10,
    current: 1,
    pageSize: 20, //每页中显示10条数据
    showSizeChanger: true,
    showQuickJumper: false,
    pageSizeOptions: ["10", "20", "30"], //每页中显示的数据
    showTotal: (total) => `共有 ${total} 条数据`, //分页中显示总的数据
    onShowSizeChange: (current, pageSize) => (pagination.pageSize = pageSize), // 改变每页数量时更新显示
    onChange: pageChange, //点击页码事件
    showSizeChange: pageSizeChange,
});

function pageChange(page, pageSize) {
    pagination.current = page;

    // 获取表格数据
    getData();
}

function pageSizeChange(current, size) {
    console.log(size);
    pagination.pageSize = size;

    // 获取表格数据
    getData();
}

let curColumn=computed(()=>columns.filter(column => column.hidden==false))
if(store.roles.includes('carEnterprise')){
    curColumn=computed(()=>columns2.filter(column => column.hidden==false))
}

watch(() => activeKey.value, val => {
    let targetColumns = store.roles.includes('carEnterprise') ? columns2 : columns;
    let column_temp;
    // if(store.roles.includes('carEnterprise')){
    //     column_temp = targetColumns.find((col) => col.key === 'application');
    //     column_temp.hidden = true;
    // }
    
    if(val == 1){
        //已审核
        column_temp = targetColumns.find((col) => col.key === 'result');
        column_temp.hidden = false;
    }else{
        column_temp = targetColumns.find((col) => col.key === 'result');
        column_temp.hidden = true;
    }
    curColumn = targetColumns.filter(column => column.hidden === false)
    getData(val);
})

const getData = () => {
    const data = {
        pageIndex: pagination.current,
        pageSize: pagination.pageSize,
        conditionMap: { ...query },
    };
    // getList(data).then((res) => {
    //    res.data.records.map((item, index) => {
    //     item.ranking = index + 1;
    //   });
    //   dataSource.value = res.data.records || [];
    //   pagination.total = res.data.total;
    // });
    let num = 20;
    let records = [];
    for (let i = 0; i < num; i++) {
        records.push({
            ranking: i + 1,
            application: "XXX公司",
            testPlate: "甘A 39383测",
            testArea: "清傅高速测试区",
            roadName: '黄河大道：峨眉山路-兴隆山路路段：南侧 / 黄河大道：峨眉山...',
            testType: '一般道路测试',
            updateTime: '2016-09-21  08:50:08',
            result: '审批通过',
            id: i + 1
        });
    }
    dataSource.value = records;
    pagination.total = num;
};

const modalRef = ref()
const modalRefJoint = ref()
const audit = (record) => {
    nextTick(() => {
        modalRefJoint.value.showModal()
    })
}
// uploadRef.value.clearFileList()
const uploadFinished = (data) => {
    console.log(data, '111111111');

}


function add(){
    router.push({
        path: "/testManage/testDetail",
        query: {
            activeKey: activeKey.value,
            type:'edit',
            from: "1"
        }
    });
}

const detail = (record) => {
    console.log(record);
    if (activeKey.value === 0) {
        router.push({
            path: "/testManage/testDetail",
            query: {
                activeKey: activeKey.value,
                from: "1"
            }
        });
    } else {
        router.push({
            path: "/testManage/testDetailResult",
            query: {
                activeKey: activeKey.value
            }
        });
    }

};

// 批量通过
const batchPass = () => {
    nextTick(() => {
        modalRef.value.showModal()
    })
}

onMounted(async () => {
    getData();
});


</script>
<style lang="less" scoped>
.review {
    padding: 13px 20px 20px 20px;
    height: calc(100vh - 70px - 57px);
    background-color: #ffffff;
}

.addBtn {
    position: fixed;
    right: 50px;
    top: 93px;
}

.inp {
    width: 13.5vw;
}

.query-item {
    display: flex;
    justify-content: space-between;


    .search-l {
        display: flex;
    }

    .search-r {
        display: flex;
    }
}

.content {
    margin: 16px 0 59px 0;
    text-align: center;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #1D2129;
}

.mr10 {
    margin-left: 10px;
}

a {
    color: #1E8EF2;
}

.radio_class {
    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: rgba(29, 33, 41, 1);
}

.area_class {
    display: flex;
}

.area_width {
    width: 420px;
    margin-left: 26px;
}

.mt22 {
    margin-top: 22px;
}

.mt32 {
    margin-top: 32px;
}

.mb85 {
    margin-bottom: 85px;
}

.mb26 {
    margin-bottom: 26px;
}

.ml26 {
    margin-left: 26px;
}

.pl30 {
    padding-left: 30px;
}

.pl43 {
    padding-left: 43px;
}

.pl15 {
    padding-left: 15px;
}

.pl55 {
    padding-left: 55px;
}

.pl89 {
    padding-left: 89px;
}

.pl91 {
    padding-left: 91px;
}

.ml28 {
    margin-left: 28px;
}

.ml40 {
    margin-left: 40px;
}

.mr24 {
    margin-right: 24px;
}

.mt32 {
    margin-top: 32px;
}

.mb56 {
    margin-bottom: 56px;
}

.mt24 {
    margin-top: 24px;
}

/deep/.ant-tabs .ant-tabs-tab {
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    margin: 0 0 0 70px;
    color: rgba(29, 33, 41, 0.7);
}

/deep/.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    color: #1D2129;
}



/deep/.ant-tabs-top>.ant-tabs-nav .ant-tabs-ink-bar {
    height: 3px;
    // background: rgba(30, 142, 242, 1);
}
</style>
